import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  convertDateYYYYMMDD,
  decryptedAdminID,
  MyModal,
} from "../../../../utility";
import { useDispatch } from "react-redux";
import { AdminAnalyticsActions } from "../../../../redux-store/store";
import ModalContainer from "../../../../components/modal_popup";
import {
  Autocomplete,
  createFilterOptions,
  FormControl,
  FormGroup,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { BiFilterAlt } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { GetAllAdminDetails, GetCompanyName } from "../../../../apiServices";
import { Typeahead } from "react-bootstrap-typeahead";

function AdminTableFilter() {
  const analyticsFilter = useSelector(
    (state) => state.AdminAnalytics.analyticsFilter
  );
  const adminAnalyticsFilter = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter
  );
  const adminAnalyticsFilterType = useSelector(
    (state) => state.AdminAnalytics.typeAnalyticsFilter.type
  );

  const dispatch = useDispatch();
  const isTeamLeader = localStorage.getItem("teamLeader");
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const [openFilter, setopenFilter] = useState(false);
  const initialObject = {
    adminId: analyticsFilter.adminId,
    startDate: adminAnalyticsFilter.startDate,
    endDate: adminAnalyticsFilter.endDate,
    page: adminAnalyticsFilter.page,
    type: adminAnalyticsFilterType,
    companyName: adminAnalyticsFilter.companyName,
  };
  const [dataFilter, setDataFilter] = useState(initialObject);
  const [adminList, setAdminList] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: adminAnalyticsFilter.startDate,
    end: adminAnalyticsFilter.endDate,
    dateFilterType: analyticsFilter.dateFilterType,
  });
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });
  const [showCustom, setShowCustom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const teamLeaderId = localStorage.getItem("teamLeaderId");
    const teamLeader = localStorage.getItem("teamLeader");
    GetAllAdminDetails()
      .then((data) => {
        const withoutleaderID = teamLeaderId;
        const withoutleader = teamLeader;
        const activeAdmins = data.filter((item) =>
          !item.Deactived &&
          item.Module !== "Developer" &&
          withoutleader == "true"
            ? item.id != withoutleaderID
            : item.id
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);

  useEffect(() => {
    async function fetchData() {
      const data = await GetCompanyName();
      setCompanyNames(data.companyDetails);
    }
    fetchData();
  }, []);
  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "currentMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 2);
      endDate = today;
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "today") {
      const dateStr = today.toISOString().split("T")[0];
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Today",
        start: dateStr,
        end: dateStr,
      }));
    } else if (val === "yesterday") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const dateStr = yesterday.toISOString().split("T")[0];
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Yesterday",
        start: dateStr,
        end: dateStr,
      }));
    } else if (val === "lastMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 2);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "custom") {
      setShowCustom(true);
    }

    setAnchorEl(null);
  };

  const handleCustomDate = (value, type) => {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  };

  const isFormValid = () => {
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApply = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      setValidationErrors({
        start: false,
        end: false,
      });
      setShowCustom(false);
    }
  };
  const handleAssignToChange = (e) => {
    const { value, name } = e.target;
    console.log(value, name);

    if (value === "myTeam") {
      const assignTo = parseInt(decryptedAdminID());

      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: true,
        adminId: assignTo,
      }));
    } else if (value === "-1") {
      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: false,
        adminId: -1, // Convert "true" to null
      }));
    } else {
      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: false,
        adminId: value, // Assign selected admin ID
      }));
    }
  };
  const handleClearAll = () => {
    setDateRange({
      start: null,
      end: null,
      dateFilterType: "Today",
    });
    setDataFilter({
      adminId: isSuperAdmin ? -1 : decryptedAdminID(),
      type: adminAnalyticsFilterType,
    });
    dispatch(
      AdminAnalyticsActions.settypeAnalyticsFilter({
        ...initialObject,
        startDate: analyticsFilter.startDate,
        endDate: analyticsFilter.endDate,
        page: 0,
      })
    );
    // dispatch(AdminAnalyticsActions.setAnalyticsStartDate(dateRange.start));
    // dispatch(AdminAnalyticsActions.setAnalyticsendDate(dateRange.end));
    // dispatch(AdminAnalyticsActions.setAnalyticsdateFilterType("Today"));
    // setSelectedFilters(null);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      AdminAnalyticsActions.settypeAnalyticsFilter({
        ...dataFilter,
        startDate: dateRange.start || adminAnalyticsFilter.startDate,
        endDate: dateRange.end || adminAnalyticsFilter.endDate,
        dateFilterType: dateRange.dateFilterType || "",
        page: 0,
      })
    );
    // console.log(dateRange.dateFilterType, "dateRange.dateFilterType");

    // dispatch(AdminAnalyticsActions.setAnalyticsStartDate(dateRange.start));
    // dispatch(AdminAnalyticsActions.setAnalyticsendDate(dateRange.end));
    // dispatch(
    //   AdminAnalyticsActions.setAnalyticsdateFilterType(dateRange.dateFilterType)
    // );
    // dispatch(AdminAnalyticsActions.setAnalyticsAdmin(dataFilter.adminId));

    setopenFilter(false);
  };
  const handleCompanyNameChange = (selected) => {
    if (selected.length > 0) {
      setDataFilter((pre) => ({
        ...pre,
        companyName: selected[0].companyName,
      }));
    } else {
      setDataFilter((pre) => ({
        ...pre,
        companyName: null,
      }));
    }
  };

  return (
    <div>
      <div
        className={`d-flex align-items-center btn btn-success`}
        variant="contained"
        onClick={() => setopenFilter(true)}
      >
        <BiFilterAlt />
        <p
          style={{
            //   backgroundColor: showRedDot ? "red" : "transparent",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></p>
        Filter
      </div>
      {openFilter && (
        <>
          <MyModal>
            <ModalContainer
              zIndex={1005}
              childComponent={
                <>
                  <div style={{ width: 400 }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <b>Filter</b>
                      </div>
                      <div
                        className="btn btn-danger"
                        onClick={() => {
                          setopenFilter(false);
                        }}
                      >
                        <AiOutlineClose />
                      </div>
                    </div>

                    <div>
                      {" "}
                      <FormControl variant="outlined" fullWidth>
                        <TextField
                          label="Custom Date"
                          value={dateRange.dateFilterType}
                          aria-controls={anchorEl ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={anchorEl ? "true" : undefined}
                          onClick={(e) => setAnchorEl(e.currentTarget)}
                          className="mt-2"
                        />
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          // defaultValue={"Today"}
                        >
                          {" "}
                          <MenuItem onClick={() => handleDateSelect("today")}>
                            Today
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDateSelect("yesterday")}
                          >
                            Yesterday
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDateSelect("currentMonth")}
                          >
                            Current Month
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDateSelect("lastMonth")}
                          >
                            Last Month
                          </MenuItem>
                          <MenuItem onClick={() => handleDateSelect("custom")}>
                            Custom Date/Month
                          </MenuItem>
                        </Menu>
                      </FormControl>
                      {showCustom && (
                        <MyModal>
                          <ModalContainer
                            zIndex={1005}
                            childComponent={
                              <div style={{ minWidth: "400px", width: "auto" }}>
                                <form onSubmit={handleApply}>
                                  <p className="text-center">
                                    Select Custom Date
                                  </p>
                                  <div className="mt-2">
                                    <label htmlFor="start">From</label>
                                    <input
                                      className={`form-control ${
                                        validationErrors.start
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      style={{ width: "100%" }}
                                      type="date"
                                      id="start"
                                      onChange={(value) =>
                                        handleCustomDate(value, "startDate")
                                      }
                                      value={dateRange.start}
                                      name="trip-start"
                                      min="2020-01-01"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                    />
                                    {validationErrors.start && (
                                      <div className="invalid-feedback">
                                        Start date is required.
                                      </div>
                                    )}
                                  </div>
                                  <div className="mt-2">
                                    <label htmlFor="end">To</label>
                                    <input
                                      className={`form-control ${
                                        validationErrors.end ? "is-invalid" : ""
                                      }`}
                                      value={dateRange.end}
                                      style={{ width: "100%" }}
                                      type="date"
                                      id="end"
                                      onChange={(value) =>
                                        handleCustomDate(value, "endDate")
                                      }
                                      name="trip-end"
                                      min="2020-01-01"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                    />
                                    {validationErrors.end && (
                                      <div className="invalid-feedback">
                                        End date is required.
                                      </div>
                                    )}
                                  </div>
                                  <div className="d-flex justify-content-end mt-3 ">
                                    <button
                                      onClick={() => {
                                        setValidationErrors({
                                          start: false,
                                          end: false,
                                        });
                                        setShowCustom(false);
                                      }}
                                      style={{
                                        backgroundColor: "#b2261c",
                                      }}
                                      className="btn rounded-pill text-white px-4  me-2"
                                    >
                                      Close
                                    </button>
                                    <button
                                      onClick={handleApply}
                                      // color="primary"
                                      className="btn rounded-pill text-white px-4"
                                      style={{
                                        backgroundColor: "#169C50",
                                      }}
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </form>
                              </div>
                            }
                          />
                        </MyModal>
                      )}
                      {adminList &&
                        (isSuperAdmin || isTeamLeader == "true") && (
                          <TextField
                            onChange={(e) => handleAssignToChange(e)}
                            name="AssignedTo"
                            id="AssignedTo"
                            className="form-control mt-2"
                            select
                            label="Assigned To"
                            value={dataFilter.adminId}
                            defaultValue={dataFilter.adminId}
                          >
                            {isSuperAdmin && (
                              <MenuItem value={-1}>ALL</MenuItem>
                            )}
                            {isTeamLeader == "true" && (
                              <MenuItem value={"myTeam"}>My team</MenuItem>
                            )}

                            {isTeamLeader == "true" && (
                              <MenuItem value={decryptedAdminID()}>
                                Only for me
                              </MenuItem>
                            )}
                            {adminList.map((el) => (
                              <MenuItem key={el.id} value={el.id}>
                                {el.userName}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      {(adminAnalyticsFilterType === "leftCompany" ||
                        adminAnalyticsFilterType === "joined" ||
                        adminAnalyticsFilterType === "selected" ||
                        adminAnalyticsFilterType === "interviewAttended" ||
                        adminAnalyticsFilterType === "interviews" ||
                        adminAnalyticsFilterType ===
                          "interviewScheduledByAdmin") && (
                        <>
                          <label htmlFor="" className="text-secondary">
                            <b style={{ fontSize: "12px" }}> Company Name :</b>
                          </label>
                          <Typeahead
                            id="company-name-typeahead"
                            placeholder="Filter company name"
                            options={companyNames}
                            labelKey={(option) =>
                              `${option.companyName} (${option.area}, ${option.city})`
                            }
                            className="mt-2"
                            selected={
                              dataFilter.companyName
                                ? companyNames.filter(
                                    (item) =>
                                      item.companyName ===
                                      dataFilter.companyName
                                  )
                                : []
                            }
                            onChange={handleCompanyNameChange}
                            inputProps={{
                              style: {
                                padding: "10px",
                                borderRadius: "4px",
                                border: "1px solid #c5c5c5",
                              },
                            }}
                          />
                        </>
                      )}
                    </div>

                    <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleClearAll}
                        sx={{ mt: 2 }}
                      >
                        Clear All
                      </button>
                      <button
                        type="submit"
                        className="btn btn-success"
                        sx={{ mt: 2, mr: 1 }}
                        onClick={handleSubmit}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
    </div>
  );
}

export default AdminTableFilter;
